import React from 'react';
import PropTypes from 'prop-types';
import styles from './header.scss';
import { t } from '../../services/i18nService';
import connectionStatusConstants from '../../constants/ConnectionStatusConstants';
import utilService from '../../services/UtilService';

const {
    STARTED_PRELOADING,
    RECONNECTING,
    CONNECTION_RESTORED,
    SAVED,
    DISCONNECTED,
    OFFLINE_MODE,
    SERVER_ERROR,
    SYNCHRONISING,
} = connectionStatusConstants;

const ConnectionStatus = React.memo(({ connectionStatus, offlineMode }) => {
    let connectedStatusText;
    let isDisconnected = false;
    let connectionIcon = 'fa-wifi';
    let assertive = false;
    let srOnly = false;

    if (!utilService.isDevelopmentQueryParameterTrue('hideConnectionStatus')) {
        switch (connectionStatus) {
        case STARTED_PRELOADING:
            connectedStatusText = t('status.startedPreloading');
            break;

        case RECONNECTING:
            assertive = true;
            connectionIcon = 'fa-refresh fa-spin';
            connectedStatusText = t('status.restoringConnectionText');
            break;

        case CONNECTION_RESTORED:
            assertive = true;
            connectedStatusText = t('status.connectionRestored');
            break;

        case SAVED:
            connectedStatusText = t('status.saved');
            break;

        case DISCONNECTED:
            isDisconnected = true;
            assertive = true;
            connectedStatusText = t('status.connectionLost');
            break;

        case OFFLINE_MODE:
            connectionIcon = 'fa-hdd-o';
            connectedStatusText = t('status.offlinemode');
            break;

        case SERVER_ERROR:
            isDisconnected = true;
            connectedStatusText = t('status.serverProblem');
            break;

        case SYNCHRONISING:
            connectedStatusText = t('status.synchronising');
            break;

        default:
            connectedStatusText = t('status.connected');
            srOnly = true;
            break;
        }
    }

    const showDisconnectedIcon = !offlineMode && isDisconnected;

    return (
        <div className={styles.connectionStatusContainer}>
            <div aria-live={assertive ? 'assertive' : 'polite'} className={styles.connectionStatus}>
                { connectedStatusText && <span role="status" className={srOnly ? 'sr-only' : ''}>{ connectedStatusText }</span> }
            </div>
            <div className={styles.icon + (isDisconnected ? ` ${styles.disconnected}` : '')}>
                <i className={`fa ${connectionIcon}`} aria-hidden="true" />
                { showDisconnectedIcon && <i className={`${styles.disconnectedIcon} fa fa-times-circle`} aria-hidden="true" /> }
            </div>
        </div>
    );
});

ConnectionStatus.propTypes = {
    connectionStatus: PropTypes.string,
    offlineMode: PropTypes.bool,
};

export default ConnectionStatus;
